import './style/QuizPageWrapper.css';
import { useState, useEffect } from 'react';
import Kata from './Kata';
import axios from 'axios';

interface Dan {
    id: string;
    danNo: number;
    name: string;
    generalDescription: string;
    requirementAsFighter: string | null;
    requirementAsCoach: string | null;
    updatedAt: string;
    kataTechniques: any[];
}

const KataWrapper = () => {

    const initial: Dan = {
        id: "",
        danNo: 0,
        name: "",
        generalDescription: "",
        requirementAsFighter: null,
        requirementAsCoach: null,
        updatedAt: "",
        kataTechniques: [],
    };

    const [Dans, setDans] = useState<Dan[]>([]);
    const [selectedDan, setSelectedDan] = useState<Dan>(initial);
    const [isDropdownVisible, setIsDropdownVisible] = useState(true);

    useEffect(() => {
        const fetchDans = async () => {
            try {
                const username = process.env.REACT_APP_API_USERNAME;
                const password = process.env.REACT_APP_API_PASSWORD;
                const token = btoa(`${username}:${password}`);
                const response = await axios.get<Dan[]>(
                    `${process.env.REACT_APP_API_URL}/Kata`,
                    {
                        headers: {
                            Authorization: `Basic ${token}`,
                        },
                    }
                );
                setDans(response.data);
            } catch (error) {
                console.error('Error fetching dans:', error);
            }
        };

        fetchDans();
    }, []);

    const handleBeltChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedId = event.target.value;
        const selectedDan = Dans.find(dan => dan.id === selectedId);
        if (selectedDan) {
            setSelectedDan(selectedDan);
            if (selectedDan.id !== "" && selectedDan.danNo !== 0) {
                setIsDropdownVisible(false);
            }
        } else {
            setSelectedDan(initial);
        }
    };

    return (
        <>
            {isDropdownVisible && (
                <div className="dropdown-container">
                    <label className="dropdown-label">Vælg kata</label>
                    <select className="belt-dropdown" value={selectedDan.id} onChange={handleBeltChange}>
                        <option value="">-- Vælg kata --</option>
                        {Dans.map((dan) => (
                            <option key={dan.id} value={dan.id}>
                                {dan.danNo}. Dan - {dan.name}
                            </option>
                        ))}
                    </select>
                </div>
            )}
            {selectedDan.id && <Kata selectedBelt={selectedDan.danNo} />}
        </>
    );
};

export default KataWrapper;